import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserService } from 'app/core/user/user.service';
import { listedplace } from 'app/types/listedplace.type';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerContactService{

  private _tranferData = new BehaviorSubject<any>(null);
  $dataDefault = this._tranferData.asObservable();
  airporttransferForm: FormGroup;

  private apiURL = this.baseUrl + 'api/customer';
  isLoading$ = new BehaviorSubject<boolean>(false);
  constructor(
      private http: HttpClient,
      @Inject('BASE_URL') private baseUrl: string
      ,private cookieService: CookieService
    ) {
        try{
            // console.log(this.cookieService.get('airporttransferForm'));
            // this._tranferData = new BehaviorSubject<any>( JSON.parse(this.cookieService.get('airporttransferForm')));
            // this.$dataDefault = this._tranferData.asObservable();
        }
        catch{

        }
     }

    setTranferData(data: FormGroup) {
      this._tranferData.next(data.getRawValue());
    
    }

    getTranferData$(): Observable<any> {
      return this._tranferData.asObservable();
    }

}